import { CarrierHttpClient } from '../../utils/HttpClient';

const getAxios = () => CarrierHttpClient;

export const Api = {
  login (payload) {
    return getAxios().post('admin_auth/sign_in', payload);
  },

  ////////////////////////
  // Admins
  ////////////////////////
  loadAdmins () {
    return getAxios().get('v2/admins');
  },

  saveAdmin (id, payload) {
    return id ? getAxios().put(`v2/admins/${id}`, payload) : getAxios().post('v2/admins', payload);
  },

  deleteAdmin (id) {
    return getAxios().delete(`v2/admins/${id}`);
  },

  ////////////////////////
  // External Services (API Tokens)
  ////////////////////////
  loadExternalServices () {
    return getAxios().get('api/v1/admin/external-services');
  },

  createExternalService (payload) {
    return getAxios().post('api/v1/admin/external-services', payload);
  },

  updateExternalService (id, payload) {
    return getAxios().put(`api/v1/admin/external-services/${id}`, payload);
  },

  revokeExternalService (id) {
    return getAxios().post(`api/v1/admin/external-services/${id}/revoke`);
  },

  regenerateExternalServiceKey (id) {
    return getAxios().post(`api/v1/admin/external-services/${id}/regenerate`);
  },

  deleteExternalService (id) {
    return getAxios().delete(`api/v1/admin/external-services/${id}`);
  },

  ////////////////////////
  // Carriers
  ////////////////////////
  loadCarriers (params) {
    return getAxios().get('v2/carriers/search', { params });
  },

  loadCarrier (id) {
    return getAxios().get(`v2/carriers/${id}`);
  },

  createCarrier (payload) {
    const form_data = new FormData();

    Object.keys(payload).forEach(key => {
      const value = payload[key];

      if (['logo'].includes(key)) {
        if (payload[key]) {
          form_data.append(key, value);
        }
      } else {
        form_data.append(key, value);
      }
    });

    return getAxios().post('v2/carriers', form_data, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },

  saveCarrier (id, payload) {
    const form_data = new FormData();

    Object.keys(payload).forEach(key => {
      const value = payload[key];

      if (['logo'].includes(key)) {
        if (payload[key]) {
          form_data.append(key, value);
        }
      } else {
        form_data.append(key, value);
      }
    });

    return getAxios().put(`v2/carriers/${id}`, form_data, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },

  deleteCarrier (carrier_id) {
    return getAxios().delete(`v2/carriers/${carrier_id}`);
  },

  ////////////////////////
  // Carrier Admins
  ////////////////////////
  loadCarrierAdmins (params) {
    return getAxios().get('v2/carrier_admins', { params });
  },

  deleteCarrierAdmin (id) {
    return getAxios().delete(`v2/carrier_admins/${id}`);
  },

  saveCarrierAdmin (id, payload) {
    return id ?
      getAxios().put(`v2/carrier_admins/${id}`, payload) :
      getAxios().post('v2/carrier_admins', payload);
  },

  ////////////////////////
  // Vendors
  ////////////////////////
  loadVendors (params) {
    return getAxios().get('v2/vendors', { params });
  },

  loadVendor (id) {
    return getAxios().get(`v2/vendors/${id}`);
  },

  updateVendor (id, payload) {
    return getAxios().put(`v2/vendors/${id}`, payload);
  },

  createVendor (payload) {
    return getAxios().post('v2/vendors', payload);
  },

  loadVendorCarrierRelationships (params) {
    return getAxios().get('v2/vendor_carrier_relationships', { params });
  },

  loadVendorCarrierRelationship (id) {
    return getAxios().get(`v2/vendor_carrier_relationships/${id}`);
  },

  updateVendorCarrierRelationship (id, payload) {
    return getAxios().put(`v2/vendor_carrier_relationships/${id}`, payload);
  },

  createVendorCarrierRelationship (payload) {
    return getAxios().post('v2/vendor_carrier_relationships', payload);
  },

  ////////////////////////
  // Embeddable E-Tickets
  ////////////////////////
  loadEmbeddableEtickets (params) {
    return getAxios().get('v2/embeddable_etickets', { params });
  },

  saveEmbeddableEticket (id, payload) {
    return id ?
      getAxios().put(`v2/embeddable_etickets/${id}`, payload) :
      getAxios().post('v2/embeddable_etickets', payload);
  },

  loadEtickets (guid) {
    return getAxios().get(`v2/etickets?embeddable_eticket_id=${guid}&per_page=10&page=1`);
  },

  ////////////////////////
  // AMBest Records
  ////////////////////////
  loadAmbestRecords (params) {
    return getAxios().get('v2/ambest_records/search', { params });
  },

  saveAmbestRecord ({ id, payload }) {
    return getAxios().put(`v2/ambest_records/${id}`, payload);
  },

  updateAmbestRecord (payload) {
    return getAxios().post('v2/ambest_records/update_process', payload, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },

  ////////////////////////
  // Products
  ////////////////////////
  loadProducts (params) {
    return getAxios().get('v2/products', { params });
  },

  saveProduct (id, payload) {
    return id ?
      getAxios().put(`v2/products/${id}`, payload) :
      getAxios().post('v2/products', payload);
  },

  deleteProduct (id) {
    return getAxios().delete(`v2/products/${id}`);
  },

  loadProductGroups (params) {
    return getAxios().get('v2/product_groups', { params });
  },

  saveProductGroup (id, payload) {
    return id ?
      getAxios().put(`v2/product_groups/${id}`, payload) :
      getAxios().post('v2/product_groups', payload);
  },

  deleteProductGroup (id) {
    return getAxios().delete(`v2/product_groups/${id}`);
  },

  ////////////////////////
  // Product Features
  ////////////////////////
  loadProductFeatures (params) {
    return getAxios().get('v2/product_features', { params });
  },

  saveProductFeature (id, payload) {
    return id ?
      getAxios().put(`v2/product_features/${id}`, payload) :
      getAxios().post('v2/product_features', payload);
  },

  deleteProductFeature (id) {
    return getAxios().delete(`v2/product_features/${id}`);
  },

  ////////////////////////
  // Form Tags
  ////////////////////////
  loadFormTags (params) {
    return getAxios().get('v2/form_tags', { params });
  },

  saveFormTag (id, payload) {
    return id ?
      getAxios().put(`v2/form_tags/${id}`, payload) :
      getAxios().post('v2/form_tags', payload);
  },

  deleteFormTag (id) {
    return getAxios().delete(`v2/form_tags/${id}`);
  },

  ////////////////////////
  // Forms
  ////////////////////////

  loadForms (params) {
    return getAxios().get('v2/forms', { params });
  },

  loadForm (id) {
    return getAxios().get(`v2/forms/${id}`);
  },

  saveForm (id, payload) {
    const form_data = new FormData();
    const { form_versions_attributes, ...form_fields } = payload;

    Object.keys(form_fields).forEach(key => {
      const value = form_fields[key];

      if (typeof value !== 'undefined' && value !== null && value !== '') {
        form_data.append(key, value);
      }
    });

    if (form_versions_attributes) {
      Object.keys(form_versions_attributes).forEach(key => {
        const value = form_versions_attributes[key];

        if (key === 'file') {
          if (value && (value instanceof File || value instanceof Blob)) {
            form_data.append(`form_versions_attributes[${key}]`, value);
          }
        } else if (Array.isArray(value)) {
          value.forEach(v => {
            if (typeof v !== 'undefined' && v !== null && v !== '') {
              form_data.append(`form_versions_attributes[${key}][]`, v);
            }
          });
        } else if (typeof value !== 'undefined' && value !== null && value !== '') {
          form_data.append(`form_versions_attributes[${key}]`, value);
        }
      });
    }

    const config = { headers: { 'Content-Type': 'multipart/form-data' } };

    return id ?
      getAxios().put(`v2/forms/${id}`, form_data, config) :
      getAxios().post('v2/forms', form_data, config);
  },

  deleteForm (id) {
    return getAxios().delete(`v2/forms/${id}`);
  },

  ////////////////////////
  // Life Quotes
  ////////////////////////
  createDataVersion (payload) {
    return getAxios().post('v2/data_versions', payload);
  },

  loadDataVersions (params) {
    return getAxios().get('v2/data_versions', { params });
  },

  loadDataVersion (id) {
    return getAxios().get(`v2/data_versions/${id}`);
  },

  copyDataVersion (id) {
    return getAxios().post(`v2/data_versions/${id}/copy`);
  },

  updateDataVersion (id, payload) {
    return getAxios().put(`v2/data_versions/${id}`, payload);
  },

  updateAnnuityQuoteProduct (id, payload) {
    return getAxios().put(`v2/products/${id}/annuity_quote`, payload);
  },

  deleteDataVersion (id) {
    return getAxios().delete(`v2/data_versions/${id}`);
  },
  ////////////////////////
  // Annuity Quotes
  ////////////////////////

  loadAnnuityQuotes ({ carrier_id }) {
    return getAxios().get(`v2/products/annuity_products/carrier/${carrier_id}`);
  },
  loadAnnuityQuote (id) {
    return getAxios().get(`v2/products/${id}`);
  },
  updateAnnuityBeta (id, payload) {
    return getAxios().put(`v2/products/beta/${id}`, payload);
  },
  updateAnnuityLive (id, payload) {
    return getAxios().put(`v2/products/live/${id}`, payload);
  },
  getContributions (id) {
    //product_id is integer
    return getAxios().get(`v2/annuity_contributions?product_id=${id}`);
  },
  postContribution (payload) {
    /*payload structure {
  "product_id": 4811,
  "beacon_id": 3678,
  "version_id": 0,
  "product_type": "Fixed Indexed Annuity",
  "product_type_detail": "Fixed Indexed Annuity",
  "maximum_initial_contribution": 1000000,
  "minimum_initial_non_qualified_contribution": 5000,
  "minimum_initial_qualified_contribution": 2500,
  "maximum_additional_contribution": 100000,
  "minimum_additional_contribution_qualified": 1000,
  "minimum_additional_contribution_non_qualified": 1000,
  "maximum_initial_contribution_non_qualified": 500000,
  "maximum_additional_contribution_non_qualified": 50000
}*/
    return getAxios().post('v2/annuity_contributions', payload);
  },
  updateContribution (id, payload) {
    //id is integer
    return getAxios().put(`v2/annuity_contributions/${id}`, payload);
  },
  deleteContribution (id) {
    //id is integer
    return getAxios().delete(`v2/annuity_contributions/${id}`);
  },
  getAges (id) {
    //product_id is integer
    return getAxios().get(`v2/annuity_ages?product_id=${id}`);
  },
  postAge (payload) {
    /*payload structure {
  "product_id": 4811,
  "beacon_id": 3678,
  "version_id": 0,
  "age": 0,
  "single_life_joint_life": "Single
}*/
    return getAxios().post('v2/annuity_ages', payload);
  },
  updateAge (id, payload) {
    //id is integer
    return getAxios().put(`v2/annuity_ages/${id}`, payload);
  },
  deleteAge (id) {
    //id is integer
    return getAxios().delete(`v2/annuity_ages/${id}`);
  },
  ////////////////////////
  // Modal Factors
  ////////////////////////
  loadQuoteRates (params) {
    return getAxios().get('v2/quote_rates', { params });
  },

  loadQuoteRate (id) {
    return getAxios().get(`v2/quote_rates/${id}`);
  },

  createQuoteRate (payload) {
    return getAxios().post('v2/quote_rates', payload);
  },

  updateQuoteRate (id, payload) {
    return getAxios().put(`v2/quote_rates/${id}`, payload);
  },

  deleteQuoteRate (id) {
    return getAxios().delete(`v2/quote_rates/${id}`);
  },

  importRates (payload) {
    return getAxios().post('v2/rates_csv_parser', payload);
  },

  ////////////////////////
  // Modal Factors
  ////////////////////////
  loadModalFactors (params) {
    return getAxios().get('v2/modal_factors', { params });
  },

  saveModalFactor (id, payload) {
    return id ?
      getAxios().put(`v2/modal_factors/${id}`, payload) :
      getAxios().post('v2/modal_factors', payload);
  },

  deleteModalFactor (id) {
    return getAxios().delete(`v2/modal_factors/${id}`);
  },

  ////////////////////////
  // Bands
  ////////////////////////
  loadBands (params) {
    return getAxios().get('v2/bands', { params });
  },

  saveBand (id, payload) {
    return id ? getAxios().put(`v2/bands/${id}`, payload) : getAxios().post('v2/bands', payload);
  },

  deleteBand (id) {
    return getAxios().delete(`v2/bands/${id}`);
  },

  ////////////////////////
  // Health Categories
  ////////////////////////
  loadHealthCategories (params) {
    return getAxios().get('v2/health_categories', { params });
  },

  saveHealthCategory (id, payload) {
    return id ?
      getAxios().put(`v2/health_categories/${id}`, payload) :
      getAxios().post('v2/health_categories', payload);
  },

  deleteHealthCategory (id) {
    return getAxios().delete(`v2/health_categories/${id}`);
  },

  ////////////////////////
  // Table Rates
  ////////////////////////
  loadTableRates (params) {
    return getAxios().get('v2/table_rates', { params });
  },

  saveTableRate (id, payload) {
    return id ?
      getAxios().put(`v2/table_rates/${id}`, payload) :
      getAxios().post('v2/table_rates', payload);
  },

  deleteTableRate (id) {
    return getAxios().delete(`v2/table_rates/${id}`);
  },
  ////////////////////////
  // Riders
  ////////////////////////
  loadRiders (params) {
    return getAxios().get('v2/life_rider_rates', { params });
  },

  saveRider (id, payload) {
    return id ?
      getAxios().put(`v2/life_rider_rates/${id}`, payload) :
      getAxios().post('v2/life_rider_rates', payload);
  },

  deleteRider (id) {
    return getAxios().delete(`v2/life_rider_rates/${id}`);
  },

  ////////////////////////
  // Annuity Riders
  ////////////////////////
  loadAnnuityRiders (params) {
    return getAxios().get('v2/annuity_riders', { params });
  },

  saveAnnuityRider (id, payload) {
    return id ?
      getAxios().put(`v2/annuity_riders/${id}`, payload) :
      getAxios().post('v2/annuity_riders', payload);
  },

  deleteAnnuityRider (id) {
    return getAxios().delete(`v2/annuity_riders/${id}`);
  },

  ////////////////////////
  // Formulas
  ////////////////////////
  loadFormulas (params) {
    return getAxios().get('v2/premium_formulas', { params });
  },

  saveFormula (id, payload) {
    return id ?
      getAxios().put(`v2/premium_formulas/${id}`, payload) :
      getAxios().post('v2/premium_formulas', payload);
  },

  deleteFormula (id) {
    return getAxios().delete(`v2/premium_formulas/${id}`);
  },

  ////////////////////////
  // LTC Quote Versions
  ////////////////////////
  createLtcQuoteVersion (payload) {
    return getAxios().post('v2/ltc_quote_versions', payload);
  },

  loadLtcQuoteVersions (id) {
    return getAxios().get(`v2/ltc_quote_versions?carrier_id=${id}`);
  },

  saveLtcQuoteVersion (id, payload) {
    return getAxios().put(`v2/ltc_quote_versions/${id}`, payload);
  },

  deleteLtcQuoteVersion (id) {
    return getAxios().delete(`v2/ltc_quote_versions/${id}`);
  },

  ////////////////////////
  // LifeDx Profile
  ////////////////////////
  loadLifeDxProfile (carrier_id) {
    return getAxios().get(`v2/carrier_lifedx_profiles?carrier_id=${carrier_id}`);
  },

  saveLifeDxProfile (id, payload) {
    return id ?
      getAxios().put(`v2/carrier_lifedx_profiles/${id}`, payload) :
      getAxios().post('v2/carrier_lifedx_profiles/', payload);
  },
  ////////////////////////
  // Investments
  ////////////////////////

  loadInvestments (product_id) {
    return getAxios().get(`v2/annuity_rates?product_id=${product_id}`);
  },

  saveNewInvestment (payload) {
    return getAxios().post('v2/annuity_rates', payload);
  },

  saveEditInvestment (payload) {
    return getAxios().put(`v2/annuity_rates/${payload.id}`, payload);
  },

  ////////////////////////
  // Life Investments
  ////////////////////////

  loadLifeInvestments (data_version_id) {
    return getAxios().get(`v2/life_investments?data_version_id=${data_version_id}`);
  },

  saveNewLifeInvestment (payload) {
    return getAxios().post('v2/life_investments', payload);
  },

  saveEditLifeInvestment (payload) {
    return getAxios().put(`v2/life_investments/${payload.id}`, payload);
  },

  deleteLifeInvestment (id) {
    return getAxios().delete(`v2/life_investments/${id}`);
  },

  ////////////////////////
  // WithdrawalsAndSurrenders
  ////////////////////////

  loadWithdrawalsAndSurrenders (product_id) {
    return getAxios().get(`v2/withdrawals_and_surrenders/${product_id}`);
  },
  ////////////////////////
  // Life Fees and Expenses
  ////////////////////////
  loadLifeFeesAndExpenses (data_version_id) {
    return getAxios().get(`v2/iul_policy_fees?data_version_id=${data_version_id}`);
  },

  saveNewLifeFeeExpense (payload) {
    return getAxios().post('v2/iul_policy_fees', payload);
  },

  saveEditLifeFeeExpense (payload) {
    return getAxios().put(`v2/iul_policy_fees/${payload.id}`, payload);
  },

  deleteLifeFeeExpense (id) {
    return getAxios().delete(`v2/iul_policy_fees/${id}`);
  }
};

export default Api;
